// This file exports types that match the Prisma schema
export const Role = {
  ADMIN: 'ADMIN',
  CLIENT: 'CLIENT'
} as const;

export const OrderStatus = {
  PENDING: 'PENDING',
  PAID: 'PAID',
  PROCESSING: 'PROCESSING',
  SHIPPED: 'SHIPPED',
  DELIVERED: 'DELIVERED',
  CANCELLED: 'CANCELLED'
} as const;

export const PaymentStatus = {
  PENDING: 'PENDING',
  PROCESSING: 'PROCESSING',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
  REFUNDED: 'REFUNDED'
} as const;

export const ShippingStatus = {
  REGISTERED: 'REGISTERED',
  IN_TRANSIT: 'IN_TRANSIT',
  DELIVERED: 'DELIVERED',
  CANCELED: 'CANCELED',
  FAILED: 'FAILED',
  RETURNED: 'RETURNED',
  PENDING: 'PENDING'
} as const;

export const InvoiceStatus = {
  ISSUED: 'ISSUED',
  CANCELED: 'CANCELED',
  STORNO: 'STORNO'
} as const;

export const VerificationStatus = {
  PENDING: 'PENDING',
  VERIFIED: 'VERIFIED',
  EXPIRED: 'EXPIRED',
  FAILED: 'FAILED'
} as const;

export type OrderStatus = typeof OrderStatus[keyof typeof OrderStatus];
export type PaymentStatus = typeof PaymentStatus[keyof typeof PaymentStatus];
export type ShippingStatus = typeof ShippingStatus[keyof typeof ShippingStatus];
export type Role = typeof Role[keyof typeof Role];
export type InvoiceStatus = typeof InvoiceStatus[keyof typeof InvoiceStatus];
export type VerificationStatus = typeof VerificationStatus[keyof typeof VerificationStatus];
